(function () {
  'use strict';

  function initCarousel(root) {
    if (root.__cmcInit) return;
    root.__cmcInit = true;

    var viewport = root.querySelector('.cmc-viewport');
    var track = root.querySelector('[data-cmc-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cmc-slide]'));
    var prevBtn = root.querySelector('[data-cmc-prev]');
    var nextBtn = root.querySelector('[data-cmc-next]');
    var dotsWrap = root.querySelector('[data-cmc-dots]');

    if (!track || slides.length === 0) return;

    var carouselEnabled = root.getAttribute('data-carousel-enabled') !== 'false';
    var loop = root.getAttribute('data-loop') !== 'false';
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
    var pauseOnHover = root.getAttribute('data-pause-hover') !== 'false';

    var index = 0;
    var autoplayTimer = null;
    var isDragging = false;
    var dragStartX = 0;
    var dragCurrentX = 0;
    var startTranslate = 0;

    function slideStep() {
      var slide = slides[0];
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function clampIndex(i) {
      if (loop) {
        if (i < 0) return slides.length - 1;
        if (i >= slides.length) return 0;
        return i;
      }
      return Math.max(0, Math.min(slides.length - 1, i));
    }

    function goTo(i, animate) {
      index = clampIndex(i);
      var offset = -index * slideStep();
      track.style.transition = animate === false ? 'none' : 'transform 400ms ease';
      track.style.transform = 'translateX(' + offset + 'px)';
      updateDots();
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    function updateDots() {
      if (!dotsWrap) return;
      var buttons = dotsWrap.querySelectorAll('.cmc-dot');
      buttons.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
      });
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cmc-dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () {
          stopAutoplay();
          goTo(i);
          startAutoplay();
        });
        dotsWrap.appendChild(dot);
      });
      updateDots();
    }

    function startAutoplay() {
      if (!autoplay || !carouselEnabled) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () { next(); }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); next(); startAutoplay(); });

    if (pauseOnHover) {
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
    }

    // Drag / swipe support
    if (carouselEnabled) {
      var pointerActive = false;

      function getX(e) {
        return e.touches ? e.touches[0].clientX : e.clientX;
      }

      function onPointerDown(e) {
        pointerActive = true;
        isDragging = false;
        dragStartX = getX(e);
        startTranslate = -index * slideStep();
        track.style.transition = 'none';
        stopAutoplay();
      }

      function onPointerMove(e) {
        if (!pointerActive) return;
        dragCurrentX = getX(e);
        var delta = dragCurrentX - dragStartX;
        if (Math.abs(delta) > 5) {
          isDragging = true;
          track.classList.add('cmc-dragging');
        }
        track.style.transform = 'translateX(' + (startTranslate + delta) + 'px)';
      }

      function onPointerUp() {
        if (!pointerActive) return;
        pointerActive = false;
        track.classList.remove('cmc-dragging');
        var delta = dragCurrentX - dragStartX;
        var threshold = slideStep() * 0.15;
        if (isDragging && Math.abs(delta) > threshold) {
          if (delta < 0) next();
          else prev();
        } else {
          goTo(index);
        }
        isDragging = false;
        dragCurrentX = 0;
        startAutoplay();
      }

      track.addEventListener('mousedown', onPointerDown);
      window.addEventListener('mousemove', onPointerMove);
      window.addEventListener('mouseup', onPointerUp);

      track.addEventListener('touchstart', onPointerDown, { passive: true });
      track.addEventListener('touchmove', onPointerMove, { passive: true });
      track.addEventListener('touchend', onPointerUp);

      track.addEventListener('click', function (e) {
        if (isDragging) {
          e.preventDefault();
        }
      });
    }

    buildDots();
    goTo(0, false);
    startAutoplay();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { goTo(index, false); }, 100);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cmc-section]').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cmc-section]');
    if (root) {
      root.__cmcInit = false;
      initCarousel(root);
    }
  });

  document.addEventListener('shopify:section:reorder', function () {
    document.querySelectorAll('[data-cmc-section]').forEach(function (root) {
      root.__cmcInit = false;
      initCarousel(root);
    });
  });
})();
